import CloseButton from "../../image/xButton.svg";

const DEFAULT_IMG_STYLE = { position: "relative", bottom: 15, left: 9 };
const USER_MODAL_IMG_STYLE = {};

export default function ModalCloseButton({
  onClick,
  className = "x-button",
  imgStyle,
  ariaLabel = "Close",
}) {
  const resolvedImgStyle =
    imgStyle !== undefined
      ? imgStyle
      : className.includes("user-x-button")
        ? USER_MODAL_IMG_STYLE
        : DEFAULT_IMG_STYLE;

  return (
    <button
      type="button"
      className={className}
      onClick={onClick}
      aria-label={ariaLabel}
    >
      <img loading="lazy" style={resolvedImgStyle} src={CloseButton} alt="" />
    </button>
  );
}
